// frontend/src/components/ReviewPage/composeChartTitle.ts
import type { KpiCascadeState } from '~/state/useKpiCascadeState'

/**
 * Compose a human-readable chart title from the current KPI cascade state.
 *
 * - 1-axis KPI → display_root label (e.g. "Net Spend")
 * - 3-axis KPI with non-null driverDisplay → "display_root driven by driverDisplay" (e.g. "Sales CpO driven by Net Spend")
 * - 3-axis KPI with null driverDisplay (e.g. Media-Driven Sales) → display_root label only, no suffix
 * - Defensive fallback: if the display label cannot be found, uses the raw value key.
 */
export function composeChartTitle(cascade: KpiCascadeState): string {
  const rootLabel = cascade.rootOptions.find((o) => o.value === cascade.root)?.label ?? cascade.root

  // Append "driven by X" only when the kpi carries an editorial driver label (driverDisplay).
  // A NULL driverDisplay (e.g. Media-Driven Sales) yields a clean, suffix-free title even though
  // `driver` is set; ratios/model_sales keep their suffix via their non-null display_driver.
  if (cascade.axisCount === 3 && cascade.driverDisplay) {
    return `${rootLabel} driven by ${cascade.driverDisplay}`
  }

  return rootLabel
}
